import CacheBase2 from '../../../services/engines/CacheBase2';

const _name = 'TemplateCache';

/**
 * TemplateCache — stores approved templates keyed by rk.
 * Extends CacheBase2 — get(rk), getAll(), addOrUpdate(), clear() inherited.
 */
class TemplateCache extends CacheBase2 {
    initialize() {
        this._name = _name;
    }

    /**
     * Returns the first template matching the given format identifier, or null.
     * Used for widget resolution — widgets are resolved by format, not by rk.
     * @param {string} format - e.g. 'widget_time'
     * @returns {object|null}
     */
    getByFormat = (format) => {
        const all = this.getAll();
        if (!all?.length) return null;
        return all.find((t) => t.format === format) ?? null;
    };
}

const templateCache = new TemplateCache();
export default templateCache;
